import http from "../httpService";

class BankAccountService {
    GetAll() {
        let result = http.get('/bankaccounts/active');
        return result;
    }
}

export default new BankAccountService();